module.exports = __webpack_public_path__ + "img/budget_2021_22_e.5bdf0ada.jpg";